import styled from "styled-components";

export const StyledLayout = styled.div`
    height: calc(100% - 100px);
`;
